export interface IWidgetData {
  widgetName: string;
  titleValue: string;
  titleValueColored?: string;
  titleColor?: 'blue' | 'green';
  ctaButtonText: string;
  subtitleValue: string;
  keywords: Array<string>;
  titleUrl: string;
  links: Array<{ value: string; url: string }>;
  isPermanent?: boolean;
  tabs: Array<string>;
  displayStartDate?: Date;
  displayEndDate?: Date;
  imageName?: string;
  imageUrl?: string;
  term?: string;
}

export interface IWidgetRequestData {
  term: string,
  country: string,
  language: string,
  brand: string,
  apiEndpoint: string,
  apigeeAuth: string,
  apigeeTokenUrl: string
}

export type widgetObject = { data: IWidgetData; tabName: string };

export const titlePartialColor = {
  green: 'green',
  blue: 'blue',
  black: 'black'
};
